export function getSlidesPerView(
    viewportWidth: number,
    approxTileWidth: number
) {
    return Math.floor(viewportWidth / approxTileWidth);
}